module.exports = __webpack_public_path__ + "static/media/김지영.3bb02723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/김지영.png
// module id = 106
// module chunks = 0